import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@axilon-apps/libs-ui-shadcn'
import { useState } from 'react'
import type { EntitiesUserResponse } from '@axilon-apps/domains-identity/types'

import AddUserForm from './components/AddUserForm/AddUserForm'
import useCreateUser from '../../hooks/use-create-user'

type CreateUserResponse = EntitiesUserResponse & { password: string }

interface Props {
  isOpen: boolean
  close: () => void
  showEmail: boolean
}

const CreateUserModal = ({ isOpen, close, showEmail }: Props) => {
  const [password, setPassword] = useState<string | null>(null)

  const onSuccess = (data: CreateUserResponse) => {
    if (data.password) {
      setPassword(data.password)
    }
  }

  const { submit, fieldErrors, reset } = useCreateUser({ onSuccess })

  const onClose = () => {
    setPassword(null)
    reset()
    close()
  }

  return (
    <Dialog open={isOpen} onOpenChange={(next) => !next && onClose()}>
      <DialogContent className="max-h-[90vh] min-w-[600px] overflow-auto">
        <DialogHeader>
          <DialogTitle>Add user</DialogTitle>
        </DialogHeader>
        <AddUserForm
          onCancel={onClose}
          password={password}
          onSubmit={submit}
          fieldErros={fieldErrors}
          showEmail={showEmail}
        />
      </DialogContent>
    </Dialog>
  )
}

export default CreateUserModal
